<template>
  <div class="o-login">
    <MoleculeLogin/>
  </div>
</template>

<script>
export default {
  name: 'OrganismLogin',

  components: {
    MoleculeLogin: () => import('@/components/molecules/MoleculeLogin')
  }
}
</script>
